/**
 * Floating buttons (layouts/partials/page-fab): scroll-to-top on every page, plus "+" on list pages
 */
export function initPageFab() {
    const fab = document.querySelector('.page-fab');
    if (!fab) {
        return;
    }

    // On list pages both show up once the regular create button has scrolled away, so "+" never duplicates it;
    // elsewhere after one screen. Measured once: content only grows below, and scroll handlers shouldn't read layout.
    const topCreate = document.querySelector('[data-cta="top"]');
    const threshold = topCreate ? topCreate.getBoundingClientRect().bottom + window.scrollY : window.innerHeight;
    const update = () => fab.classList.toggle('is-shown', window.scrollY > threshold);
    window.addEventListener('scroll', update, { passive: true });
    update();

    fab.querySelector('.page-fab__btn--top').addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
}
